export default {
  'termsAndConditions.acceptRequired':
    'Acceptance of these terms and conditions is required to access the service. Please contact your financial institution for questions.',
  'termsAndConditions.cancel': 'No, Cancel',
  'termsAndConditions.confirmDecline': 'Are you sure you want to decline?',
  'termsAndConditions.declineDisclosure': 'Yes, Decline',
  'termsAndConditions.emailed': 'Terms and Conditions emailed'
};
